import { Alert, Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ColorField = styled('label')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: theme.spacing(1.5),
	marginTop: theme.spacing(2),
}));

export const ColorSwatch = styled('input')(({ theme }) => ({
	width: 40,
	height: 40,
	padding: 0,
	border: 'none',
	backgroundColor: 'transparent',
	cursor: 'pointer',
	borderRadius: theme.shape.borderRadius,
}));

export const FormError = styled(Alert)(({ theme }) => ({
	marginTop: theme.spacing(2),
}));

export const ModalActions = styled(Box)(({ theme }) => ({
	display: 'flex',
	justifyContent: 'flex-end',
	gap: theme.spacing(1.5),
	padding: theme.spacing(1, 3, 3),
}));

export const ImagePickerArea = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'hasImage',
})<{ hasImage: boolean }>(({ theme, hasImage }) => ({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	gap: theme.spacing(1),
	padding: theme.spacing(3),
	marginTop: theme.spacing(2),
	border: `2px dashed ${hasImage ? theme.palette.success.main : theme.palette.divider}`,
	borderRadius: theme.shape.borderRadius,
	backgroundColor: hasImage
		? theme.palette.success.main + '0D'
		: theme.palette.background.default,
	cursor: 'pointer',
	transition: 'all 0.2s ease',
	'&:hover': {
		borderColor: theme.palette.primary.main,
		backgroundColor: theme.palette.primary.main + '0D',
	},
}));

export const ImageRule = styled(Typography)(({ theme }) => ({
	marginTop: theme.spacing(1),
	color: theme.palette.text.secondary,
	fontSize: '0.75rem',
	lineHeight: 1.4,
}));

export const ImageClearButton = styled('button')(({ theme }) => ({
	marginTop: theme.spacing(1),
	padding: 0,
	border: 'none',
	background: 'none',
	color: theme.palette.error.main,
	font: 'inherit',
	fontSize: '0.8rem',
	cursor: 'pointer',
	'&:hover': {
		textDecoration: 'underline',
	},
}));

export const ImagePreviewWrapper = styled(Box)(({ theme }) => ({
	width: 72,
	height: 72,
	borderRadius: theme.shape.borderRadius,
	overflow: 'hidden',
	border: `1px solid ${theme.palette.divider}`,
	flexShrink: 0,
	'& img': {
		width: '100%',
		height: '100%',
		objectFit: 'cover',
	},
}));
